const IDEAL_TIME = 2 * 60 * 1000; // 2 minutes
const IS_INCREASE = false;
const SPEED = 1;
let interval_Time = 2 * 60 * 1000; // 2 minutes

export function getAPIWaitingTime(startingTime = 0, currentTime = 0) {
  // first call
  if (currentTime - startingTime < 10) {
    return IDEAL_TIME;
  } else {
    if (IS_INCREASE) {
      interval_Time = interval_Time / SPEED;
    } else {
      interval_Time = interval_Time * SPEED;
    }

    return interval_Time;
  }
}
